// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__14xZT","left":"InfoRow_left__3rhX0"};